import {FieldConfig} from '../../dynamic-field/field.config';
import {MultipleOptionType} from '../../dynamic-field/field-type.enum';
import {FieldOrientationEnum, LabelPositionEnum} from './multi-field.enums';

export interface MultiOptionConfig extends FieldConfig<any> {
    source: {
        [key: string]: string | OptionSourceData;
    };
    optionType: MultipleOptionType;
    orientation?: FieldOrientationEnum;
    labelPosition?: LabelPositionEnum;
    outlineHidden?: boolean;
}

export interface OptionSourceData {
    text: string;
    readonly?: boolean;
}
